export const CPF_FORMATTED_REGEX = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
